export enum InteractionComponent {
    OfferDetails = "offer_details",
    ThumbsUpDown = "thumbs_up_down",
    OffersPage = "offers_page",
    ShareAppPage = "share_app_page",
    SponsorVideoPage = "sponsor_video_page",
    SharePage = "share_page",
    LocationPage = "location_page",
    SearchingPage = "searching_page",
    SettingsPage = "settings_page",
    AboutPage = "about_page",
    HomePage = "home_page",
    LoginPage = "login_page",
    ValidatePage = "validate_page",
    ReferrerPage = "referrer_page",
    ForgotPasswordPage = "forgot_password_page",
    ThanksPage = "thanks_page",
    SponsorPage = "sponsor_page",
    WelcomePage = "welcome_page"
}
